import { Skeleton } from '@/shared/components/ui/skeleton';

const ConnectorSkeleton = () => {
  return (
    <div className="$tw-flex $tw-h-96 $tw-flex-col $tw-items-center $tw-gap-2 $tw-rounded-lg $tw-border $tw-border-foreground/20 $tw-bg-background $tw-p-3">
      <Skeleton className="$tw-h-14 $tw-w-full $tw-bg-background-2" />
      <Skeleton className="$tw-my-2 $tw-h-80 $tw-w-24 $tw-rounded $tw-bg-background-2" />
    </div>
  );
};

export default ConnectorSkeleton;
